<template>
  <div class="invoice-manage">
    <ots-main-title></ots-main-title>
    <div>
      <div class="searchCon">
        <div class="searchMain">
          <ots-refer
            :selectList="selectList"
            :request-form="selectForm"
            @search="getResult"
          />
        </div>
      </div>
      <div class="content">
        <ots-table-group-new
          :tableHeader="tableHeader"
          :tableOption="tableOption"
          :tableData="tableData"
          :batchOperBtn="batchOperBtn"
          :pagination="pagination"
          @changeNum="changeSize"
          @changePage="changePage"
          @handleSelectionChange="handleSelectionChange"
        ></ots-table-group-new>
      </div>
      <ots-custom-dialog
        :dialog.sync="exportDialog"
        title="导出设置"
        width="40%"
      >
        <template v-slot:content>
          <div class="export-setting">
            <div>请选择数据范围</div>
            <div class="mt10">
              <el-radio-group v-model="exportType">
                <el-radio-button label="2">选中数据</el-radio-button>
                <el-radio-button label="1">查询结果数据</el-radio-button>
                <el-radio-button label="3">全部数据</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="exportDialog = false">取消</el-button>
          <el-button round type="primary" @click="exportData">确定</el-button>
        </template>
      </ots-custom-dialog>
      <ots-custom-dialog
        :dialog.sync="batchDialog"
        title="批量下载发票"
        width="40%"
      >
        <template v-slot:content>
          <div class="export-setting">
            <div>请选择下载范围</div>
            <div class="mt10">
              <el-radio-group v-model="batchType">
                <el-radio-button label="2">选中数据</el-radio-button>
                <el-radio-button label="1">查询结果数据</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="batchDialog = false">取消</el-button>
          <el-button round type="primary" @click="batchDownload">确定</el-button>
        </template>
      </ots-custom-dialog>
    </div>
  </div>
</template>

<script>
import { getSelectPlanFn } from '@/http/modules/examSet/examBatch'

const timeShortCuts = [
  {
    text: "今天",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "昨天",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近一周",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", [start, end]);
    },
  },
]

export default {
  name: "invoiceManage",
  data() {
    return {
      exportDialog: false,
      batchDialog: false,
      exportType: null,
      batchType: null,
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "开票状态",
          type: "select",
          requestKey: "ebillstate",
          label: "key",
          value: "value",
          data: [
            { key: "全部", value: "" },
            { key: "已开票", value: 1 },
            { key: "开票中", value: 0 },
            { key: "未开票", value: -1 },
          ],
        },
        {
          title: "缴费课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        },
        {
          title: "付款方式",
          type: "select",
          requestKey: "payType",
          label: "key",
          value: "value",
          data: [
            { key: "全部", value: "" },
            { key: "平台在线缴费", value: "1" },
            { key: "第三方自主缴费", value: "2" },
          ],
        },
        {
          title: "订单号",
          type: "input",
          requestKey: "backId",
          placeholder: "请输入",
        },
        {
          title: "开票日期",
          type: "daterange",
          requestKey: "dateRange_bill",
          pickerOptions: {
            shortcuts: timeShortCuts,
          },
        },
        {
          title: "缴费日期",
          type: "daterange",
          requestKey: "dateRange_pay",
          pickerOptions: {
            shortcuts: timeShortCuts,
          },
        },
        {
          title: "关键字",
          type: "input",
          requestKey: "keyword",
          placeholder: "姓名/证件号",
        },
      ],
      selectForm: {
        planId: null,
        ebillstate: "",
        courseId: "",
        payType: "",
        backId: "",
        dateRange_bill: [],
        dateRange_pay: [],
        billDateBegin: "",
        billDateEnd: "",
        payDateBegin: "",
        payDateEnd: "",
        keyword: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
          width: "70",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "缴费课程",
          prop: "courseName",
        },
        {
          title: "付款方式",
          prop: "payType",
          width: "120",
        },
        {
          title: "缴费时间",
          prop: "payDate",
        },
        {
          title: "金额",
          prop: "money",
          width: "80",
        },
        {
          title: "订单号",
          prop: "backId",
        },
        {
          title: "开票状态",
          prop: "ebillstate",
          width: "90",
        },
        {
          title: "开票时间",
          prop: "billDate",
        },
        {
          title: "操作",
          type: "button",
          width: "100",
          formatter: () => "<span>下载发票</span>",
          disableFn: (val) => val.row.ebillstateCode !== 1,
          click: this.handleDownload,
          align: "right",
        },
      ],
      tableOption: {
        multiple: true,
      },
      tableData: [],
      batchOperBtn: [
        {
          title: "导出",
          icon: "iconfont icon-daochu",
          click: this.showExportDialog,
        },
        {
          title: "批量下载",
          icon: "el-icon-download",
          click: this.showBatchDialog,
        },
      ],
      pagination: {
        total: 0,
      },
      multipleSelectList: [],
    };
  },
  watch: {
    "selectForm.planId"() {
      this.getResult();
      this.getPlanCourseData(this.selectForm.planId);
    },
    "selectForm.dateRange_bill"(val) {
      if (val && val.length) {
        this.selectForm.billDateBegin = val[0];
        this.selectForm.billDateEnd = val[1];
      } else {
        this.selectForm.billDateBegin = "";
        this.selectForm.billDateEnd = "";
      }
    },
    "selectForm.dateRange_pay"(val) {
      if (val && val.length) {
        this.selectForm.payDateBegin = val[0];
        this.selectForm.payDateEnd = val[1];
      } else {
        this.selectForm.payDateBegin = "";
        this.selectForm.payDateEnd = "";
      }
    },
  },
  mounted() {
    this.getPlan();
  },
  methods: {
    getPlan() {
      getSelectPlanFn({ needAudit: 3 }).then(({ data }) => {
        this.$set(this.selectList[0], "data", data);
        if (data.length > 0) {
          this.selectForm.planId = data[0].id;
        }
      });
    },
    getPlanCourseData(planId) {
      this.$api.applyManage.getPlanCourse({ planId }).then(({ data }) => {
        const courseList = [{ courseId: "", courseName: "全部" }, ...data];
        this.$set(this.selectList[2], "data", courseList);
      });
    },
    dealParamsWithArray(obj) {
      let params = { ...obj };
      for (let item in params) {
        if (Array.isArray(params[item])) {
          delete params[item];
        }
      }
      return params;
    },
    getTableList() {
      let params = { ...this.selectForm };
      params = this.cleanParams(params);
      this.$api.applyManage.getInvoiceList(params).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        }
      });
    },
    getResult() {
      this.selectForm.page = 1;
      this.getTableList();
    },
    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
    handleSelectionChange(res) {
      this.multipleSelectList = res.map((item) => item.invoiceId);
    },
    handleDownload(row) {
      this.$api.applyManage
        .downloadInvoice({ invoiceId: row.invoiceId })
        .then((res) => {
          if (res.code === 1) {
            window.open(res.data);
          }
        });
    },
    showExportDialog() {
      this.exportType = null;
      this.exportDialog = true;
    },
    showBatchDialog() {
      this.batchType = null;
      this.batchDialog = true;
    },
    cleanParams(params) {
      params = this.dealParamsWithArray(params);
      if (params.ebillstate === "") {
        params.ebillstate = null;
      }
      if (params.payType === "") {
        params.payType = null;
      }
      return params;
    },
    exportData() {
      let { exportType, multipleSelectList } = this;
      if (!exportType) {
        this.$message.warning("请选择数据范围");
        return;
      }
      if (exportType === "2" && !multipleSelectList.length) {
        this.$message.warning("请选择导出数据");
        return;
      }
      let { page, size, ...params } = this.selectForm;
      params = this.cleanParams(params);
      let newParams = {
        ...params,
        exportType: Number(exportType),
        ids: multipleSelectList.toString(),
      };
      this.$api.applyManage.exportInvoiceList(newParams).then((res) => {
        if (res.code === 1) {
          this.exportDialog = false;
          window.open(res.data);
        }
      });
    },
    batchDownload() {
      let { batchType, multipleSelectList } = this;
      if (!batchType) {
        this.$message.warning("请选择下载范围");
        return;
      }
      if (batchType === "2" && !multipleSelectList.length) {
        this.$message.warning("请选择下载数据");
        return;
      }
      let { page, size, ...params } = this.selectForm;
      params = this.cleanParams(params);
      let newParams = {
        ...params,
        exportType: Number(batchType),
        ids: multipleSelectList.toString(),
      };
      this.$api.applyManage.batchDownloadInvoice(newParams).then((res) => {
        if (res.code === 1) {
          this.batchDialog = false;
          res.data.forEach((url) => {
            window.open(url);
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.content {
  position: relative;
  margin-top: 16px;
  background: #fff;
  border-radius: 8px;
}
.export-setting {
  .mt10 {
    margin-top: 10px;
  }
}
</style>
